if (!customElements.get('region-state-quiz')) {
  customElements.define(
    'region-state-quiz',
    class RegionStateQuiz extends HTMLElement {
      constructor() {
        super();
        this.currentStep = 1;
        this.selection = {
          regionHandle: '',
        };
        this.onBackClick = this.onBackClick.bind(this);
        this.onRegionClick = this.onRegionClick.bind(this);
        this.onCardKeydown = this.onCardKeydown.bind(this);
      }

      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('.region-state-quiz__step'));
        this.totalSteps = this.steps.length || Number(this.dataset.totalSteps) || 2;
        this.headingEl = this.querySelector('[data-quiz-heading]');
        this.progressEl = this.querySelector('[data-quiz-progress]');
        this.backButton = this.querySelector('[data-quiz-back]');
        this.stateGrid = this.querySelector('[data-state-grid]');

        this.querySelectorAll('[data-quiz-region]').forEach((btn) => {
          btn.addEventListener('click', this.onRegionClick);
          btn.addEventListener('keydown', this.onCardKeydown);
        });

        if (this.backButton) {
          this.backButton.addEventListener('click', this.onBackClick);
        }

        this.goToStep(1);
      }

      disconnectedCallback() {
        this.querySelectorAll('[data-quiz-region]').forEach((btn) => {
          btn.removeEventListener('click', this.onRegionClick);
          btn.removeEventListener('keydown', this.onCardKeydown);
        });
        if (this.backButton) {
          this.backButton.removeEventListener('click', this.onBackClick);
        }
      }

      onCardKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          event.currentTarget.click();
        }
      }

      onBackClick(event) {
        event.preventDefault();
        if (this.currentStep <= 1) return;
        this.goToStep(this.currentStep - 1);
      }

      onRegionClick(event) {
        const btn = event.currentTarget;
        this.selection.regionHandle = (btn.dataset.regionHandle || '').trim().toLowerCase();
        this.setSelectedCard('[data-quiz-region]', btn);
        this.applyStateFilter(this.selection.regionHandle);
        this.goToStep(2);
      }

      applyStateFilter(regionHandle) {
        let visibleCount = 0;
        this.querySelectorAll('[data-quiz-state]').forEach((card) => {
          const column = card.closest('.f-column') || card;
          const cardRegion = (card.dataset.regionHandle || '').trim().toLowerCase();
          const show = Boolean(regionHandle) && cardRegion === regionHandle;
          column.hidden = !show;
          card.classList.toggle('is-hidden', !show);
          if (show) visibleCount += 1;
        });

        this.adjustGridColumns(this.stateGrid, visibleCount);
      }

      adjustGridColumns(grid, visibleCount) {
        if (!grid || !visibleCount) return;

        const clamp = (value) => Math.max(1, Math.min(Number(value) || 1, visibleCount));
        const mobile = clamp(grid.dataset.colsMobile);
        const tablet = clamp(grid.dataset.colsTablet);
        const desktop = clamp(grid.dataset.colsDesktop);

        Array.from(grid.classList)
          .filter((name) => /^(?:md:|lg:)?f-grid-\d+-cols$/.test(name))
          .forEach((name) => grid.classList.remove(name));

        grid.classList.add(`f-grid-${mobile}-cols`, `md:f-grid-${tablet}-cols`, `lg:f-grid-${desktop}-cols`);
      }

      setSelectedCard(selector, activeBtn) {
        this.querySelectorAll(selector).forEach((el) => {
          el.classList.toggle('is-selected', el === activeBtn);
          el.setAttribute('aria-pressed', el === activeBtn ? 'true' : 'false');
        });
      }

      goToStep(step) {
        this.currentStep = step;

        this.steps.forEach((panel) => {
          const panelStep = Number(panel.dataset.step);
          const isActive = panelStep === step;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });

        if (this.headingEl) {
          const activePanel = this.steps.find((panel) => Number(panel.dataset.step) === step);
          const heading = activePanel?.dataset.stepHeading || '';
          this.headingEl.textContent = heading;
        }

        if (this.progressEl) {
          this.progressEl.textContent = `Step ${step} of ${this.totalSteps}`;
        }

        if (this.backButton) {
          this.backButton.hidden = step <= 1;
        }

        if (step === 1 && this.selection.regionHandle) {
          const selectedRegion = this.querySelector(
            `[data-quiz-region][data-region-handle="${this.selection.regionHandle}"]`
          );
          if (selectedRegion) this.setSelectedCard('[data-quiz-region]', selectedRegion);
        }
      }
    }
  );
}
